import { EMAIL_REGEX } from "@zenith/data/constants";

export const setFirstNameValidations = (firstName: string) => {
  const hasError = false;
  const message = "";

  if (firstName === "") {
    return {
      hasError: true,
      message: "First Name is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setLastNameValidations = (lastName: string) => {
  const hasError = false;
  const message = "";

  if (lastName === "") {
    return {
      hasError: true,
      message: "Last Name is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setDateOfBirthValidations = (dateOfBirth: string) => {
  const hasError = false;
  const message = "";

  if (dateOfBirth === "") {
    return {
      hasError: true,
      message: "Date of Birth is required",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setEmailValidations = (email: string) => {
  const hasError = false;
  const message = "";

  if (email && !EMAIL_REGEX.test(email)) {
    return {
      hasError: true,
      message: "Email Address not valid",
    };
  }

  return {
    hasError,
    message,
  };
};

export const setPhoneNumberValidations = (phoneNumber: string) => {
  const hasError = false;
  const message = "";

  if (phoneNumber === "") {
    return {
      hasError: true,
      message: "Phone Number is required",
    };
  } else if (phoneNumber.length < 10) {
    return {
      hasError: true,
      message: "Phone Number not valid",
    };
  }
  return {
    hasError,
    message,
  };
};

export const setRelationshipValidations = (relationship: string) => {
  const hasError = false;
  const message = "";

  if (relationship === "") {
    return {
      hasError: true,
      message: "Relationship is required",
    };
  }
  return {
    hasError,
    message,
  };
};
